$(document).ready(function () {
  if($('.banner-list .banner_box').length > 1){  
      $('.banner-list').slick({
        arrows: false,
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        adaptiveHeight: true
      });
    }

   
    $('.reviews-slider').slick({
        arrows: true,
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 1,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 990,
                settings: {
                slidesToShow: 1,
                slidesToScroll: 1
                }
            }
        ]
    });
    
    $('.product-slider').slick({
    dots: false,
    arrows:true,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1366,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
    
});

/* Tabs */
document.querySelectorAll('.tab-btn').forEach(btn => {
  btn.addEventListener('click', function() {
    document.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
    this.classList.add('active');

    let tab = this.dataset.tab;

    document.querySelectorAll('.tab-content').forEach(c => c.classList.add('hidden'));
    document.getElementById(tab).classList.remove('hidden');
  });
});

$('.velaPopup .hotline_header').click(function(event){
  $(this).toggleClass('active');
});

document.addEventListener("DOMContentLoaded", function () {
  $('.custom-sidebar__products').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      rows: 3,              
      slidesPerRow: 1,      
      dots: false,
      arrows: true,
      infinite: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            rows: 1,     
            slidesPerRow: 1
          }
        }
      ]
  });
   const mobileDrawer = document.querySelector('.mobile-facets__wrapper');
  if (mobileDrawer) {
    const summaryToggle = mobileDrawer.querySelector('.mobile-facets__open-wrapper');
    if (summaryToggle) {
      summaryToggle.addEventListener('click', function () {
        // Drawer opens with a CSS transition, so wait for it to be visible
        setTimeout(function () {
          $('.custom-sidebar__products').slick('refresh');
        }, 450); // matches MenuDrawer's ~400ms closeAnimation + buffer
      });
    }
  }
});

/**
 * Collection Grid / List View Toggle
 * Attach this script to your Shopify theme assets and load it in the section.
 * Usage: {{ 'collection-view-toggle.js' | asset_url | script_tag }}
 */

(function () {
  const STORAGE_KEY = 'collectionView';
  const GRID_CLASS  = 'collection-list-view'; // added to #product-grid when list is active

  function init() {
    const buttons   = document.querySelectorAll('.changeView');
    const grid      = document.getElementById('product-grid');

    if (!buttons.length || !grid) return;

    // Restore saved preference
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'list') applyView('list', buttons, grid);

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const view = this.dataset.view; // 'grid' or 'list'
        applyView(view, buttons, grid);
        localStorage.setItem(STORAGE_KEY, view);
      });
    });
  }

  function applyView(view, buttons, grid) {
    // Toggle active class on buttons
    buttons.forEach(function (btn) {
      btn.classList.toggle('changeViewActive', btn.dataset.view === view);
    });

    // Toggle list class on the product grid
    if (view === 'list') {
      grid.classList.add(GRID_CLASS);
    } else {
      grid.classList.remove(GRID_CLASS);
    }
  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init after Shopify section re-renders (infinite scroll / filter AJAX)
  document.addEventListener('shopify:section:load', init);
})();


 function closePopup() {
    const popup = document.getElementById('form-popup');
    if (popup) {
      popup.remove(); // completely remove popup from DOM
    }

    cleanUrl();
  }

  function cleanUrl() {
    // Build clean URL (no query, no hash)
    const cleanPath = window.location.origin + window.location.pathname;

    // Replace current history entry
    window.history.replaceState({}, document.title, cleanPath);
  }